export const PURGE_APP_DATA = 'purgeAppData';
export const SET_APP_DATA = 'setAppData';
export const SET_LOADING = 'setLoading';
export const SET_ERROR = 'setGlobalError';
export const SWITCH_GOD_MODE = 'switchGodMode';
